<div class="location-editor-container" *ngIf="viewModel$ | async as viewModel">
  <!-- Form fields -->
  <div class="location-form">
    <!-- Row 1: Unit # and Address -->
    <div class="form-row">
      <div *ngIf="viewModel.showUnitNumber" class="form-field unit-field">
        <label for="unitNumber">Unit #</label>
        <input
          id="unitNumber"
          type="text"
          pInputText
          [ngModel]="viewModel.locationEditor?.unitNumber"
          [disabled]="viewModel.jobNotInZone"
          (ngModelChange)="
            store.dispatch(
              actions.unitNumberEntered({
                locationType: viewModel.locationType,
                unitNumber: $event,
              })
            )
          "
          class="no-min-width"
        />
      </div>
      <div class="form-field address-field" *ngIf="googleHelper.loaded | async">
        <label for="address">Address</label>
        <div class="p-inputgroup">
          <input
            id="address"
            [ngModel]="viewModel.locationEditor?.address"
            #googleAutocomplete="ngx-places"
            #googleAutocompleteModel="ngModel"
            ngx-gp-autocomplete
            pInputText
            autocomplete="off"
            [disabled]="viewModel.jobNotInZone"
            (onAddressChange)="
              store.dispatch(
                actions.googleAutocompleteAddressSelected({
                  address: $event,
                  locationType: viewModel.locationType,
                  openWizard: viewModel.openWizard,
                })
              )
            "
            (input)="
              store.dispatch(
                actions.googleAutocompleteInputChanged({
                  address: $event.target.value,
                  locationType: viewModel.locationType,
                })
              )
            "
            [inputStyle]="{ width: '100%' }"
            [ngClass]="{
              'location-invalid': viewModel.locationInvalid,
            }"
          />
          <button
            type="button"
            pButton
            pRipple
            icon="pi pi-map-marker"
            class="p-button-secondary p-button-outlined"
            pTooltip="Add a location without using the autocomplete"
            [disabled]="viewModel.jobNotInZone"
            (click)="
              store.dispatch(
                actions.addLocationManuallyButtonClicked({
                  locationType: viewModel.locationType!,
                })
              )
            "
          ></button>
        </div>
        <small
          *ngIf="viewModel.locationInvalid && googleAutocompleteModel.dirty"
          class="field-error-message"
        >
          You must use autocomplete to set the location.
        </small>
      </div>
    </div>

    <!-- Row 2: Building Type and Size -->
    <div class="form-row two-columns" *ngIf="viewModel.showDetails">
      <div class="form-field">
        <label for="buildingType"
          >Building Type
          {{ viewModel.dwellingTypeMandatory ? '(Required)' : '' }}</label
        >
        <p-dropdown
          id="buildingType"
          [ngModel]="viewModel.locationEditor?.buildingType"
          #buildingTypeModel="ngModel"
          optionLabel="label"
          optionValue="value"
          [options]="viewModel.buildingTypeOptions"
          [disabled]="viewModel.jobNotInZone"
          [required]="viewModel.dwellingTypeMandatory"
          [appControlMeta]="viewModel.dwellingTypeControlKey"
          (onChange)="
            store.dispatch(
              actions.buildingTypeSelected({
                buildingType: $event.value,
                locationType: viewModel.locationType,
              })
            )
          "
          [style]="{ width: '100%' }"
        ></p-dropdown>
        <app-validation-messages
          [control]="buildingTypeModel.control"
          [requireTouched]="true"
        ></app-validation-messages>
      </div>
      <div class="form-field">
        <label for="size"
          >{{ viewModel.sizeLabel }}
          {{ viewModel.bedroomsMandatory ? '(Required)' : '' }}</label
        >
        <p-dropdown
          id="size"
          optionLabel="label"
          optionValue="value"
          [ngModel]="viewModel.locationEditor?.size"
          #sizeModel="ngModel"
          [options]="viewModel.sizeOptions"
          [disabled]="viewModel.jobNotInZone"
          [required]="viewModel.bedroomsMandatory"
          [appControlMeta]="viewModel.bedroomsControlKey"
          (onChange)="
            store.dispatch(
              actions.sizeSelected({
                size: $event.value,
                locationType: viewModel.locationType,
              })
            )
          "
          [style]="{ width: '100%' }"
        ></p-dropdown>
        <app-validation-messages
          [control]="sizeModel.control"
          [requireTouched]="true"
        ></app-validation-messages>
      </div>
    </div>

    <!-- Row 3: Access and Elevator Type -->
    <div
      [ngClass]="{
        'form-row': true,
        'single-column': !viewModel.showElevatorType,
        'two-columns': viewModel.showElevatorType,
      }"
      *ngIf="viewModel.showAccess"
    >
      <div class="form-field">
        <label for="access"
          >Access
          {{ viewModel.accessMandatory ? '(Required)' : '' }}</label
        >
        <p-dropdown
          id="access"
          optionLabel="label"
          optionValue="value"
          [styleClass]="viewModel.showElevatorType ? null : 'w-full'"
          [ngModel]="viewModel.locationEditor?.access"
          #accessModel="ngModel"
          [options]="viewModel.accessOptions"
          [disabled]="viewModel.jobNotInZone"
          [required]="viewModel.accessMandatory"
          [appControlMeta]="viewModel.accessControlKey"
          (onChange)="
            store.dispatch(
              actions.accessSelected({
                access: $event.value,
                locationType: viewModel.locationType,
              })
            )
          "
          [style]="{ width: '100%' }"
        ></p-dropdown>
        <app-validation-messages
          [control]="accessModel.control"
          [requireTouched]="true"
        ></app-validation-messages>
      </div>
      <div class="form-field" *ngIf="viewModel.showElevatorType">
        <label for="elevatorType">Elevator Type</label>
        <p-dropdown
          id="elevatorType"
          optionLabel="label"
          optionValue="value"
          [ngModel]="viewModel.locationEditor?.elevatorType"
          [options]="viewModel.elevatorTypeOptions"
          [disabled]="viewModel.jobNotInZone"
          (onChange)="
            store.dispatch(
              actions.elevatorTypeSelected({
                elevatorType: $event.value,
                locationType: viewModel.locationType,
              })
            )
          "
          [style]="{ width: '100%' }"
        ></p-dropdown>
      </div>
    </div>

    <!-- Row 4: Floor -->
    <div class="form-row single-column" *ngIf="viewModel.showFloor">
      <div class="form-field">
        <label for="floor">Floor</label>
        <p-inputNumber
          id="floor"
          [showButtons]="true"
          [ngModel]="viewModel.locationEditor?.floor"
          [suffix]="viewModel.floorSuffix"
          [min]="2"
          incrementButtonIcon="pi pi-plus"
          decrementButtonIcon="pi pi-minus"
          buttonLayout="horizontal"
          incrementButtonClass="p-button-outlined"
          decrementButtonClass="p-button-outlined"
          (onInput)="
            store.dispatch(
              actions.floorInputChanged({
                floor: $event.value,
                locationType: viewModel.locationType,
              })
            )
          "
        ></p-inputNumber>
      </div>
    </div>

    <!-- Row 5: Access Notes -->
    <div class="form-row single-column" *ngIf="viewModel.showAccessNotes">
      <div class="form-field">
        <label for="accessNotes">Access Notes</label>
        <textarea
          id="accessNotes"
          [rows]="5"
          [cols]="50"
          pInputTextarea
          [ngModel]="viewModel.locationEditor?.accessNotes"
          [disabled]="viewModel.jobNotInZone"
          (ngModelChange)="
            store.dispatch(
              actions.accessNotesTextAreaContentChanged({
                accessNotes: $event,
                locationType: viewModel.locationType,
              })
            )
          "
          [style]="{ width: '100%' }"
        ></textarea>
      </div>
    </div>
  </div>
  <app-job-manually-add-location></app-job-manually-add-location>
</div>
